import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RegulatoryOffering from "@/pages/RegulatoryOffering";

export const Route = createFileRoute("/es/servicios/regulatory-affairs/estrategia-reguladora-para-md-e-ivd")({
  head: () => buildRouteHead("/es/servicios/regulatory-affairs/estrategia-reguladora-para-md-e-ivd"),
  component: RegulatoryOffering,
});

